import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { BoatPhotosQuery } from '../gql/graphql';

const boatPhotos = graphql(/* GraphQL */ `
  query boatPhotos($boatId: Int, $boatSlug: String) {
    boatPhotos(boatId: $boatId, boatSlug: $boatSlug) {
      boatId
      imageUrl
      isHero
    }
  }
`);

const useGetBoatPhotos = (boatId?: number, boatSlug?: string) => {
  const { data, isLoading } = useQuery<BoatPhotosQuery>({
    queryKey: ['boatPhotos', boatId],
    queryFn: async () =>
      graphqlRequest<BoatPhotosQuery>(boatPhotos, {
        boatId,
        boatSlug,
      }), // Public endpoint, no auth needed
    staleTime: 3600000,
    retry: shouldRetryQuery,
  });

  return {
    boatPhotos: data,
    boatPhotosLoading: isLoading,
  };
};

export default useGetBoatPhotos;
